import {createRouter, createWebHistory} from 'vue-router';
import {useAccountStore} from '@/stores/AccountStore.js';
import Messenger from '@/views/messenger/Messenger.vue';
import {useContractsStore} from "@/stores/ContractsStore.js";
import {useOnlineUsersStore} from "@/stores/OnlineUsersStore.js";
import {useMessagesStore} from "@/stores/MessagesStore.js";
import {emitter} from "@/infrastructure/event_bus.js";

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/login/LoginScreen.vue'),
        meta: {withoutAuth: true}
    },
    {
        path: '/role',
        name: 'Role',
        component: () => import('@/views/login/RoleChooserScreen.vue'),
        meta: {requiresAuth: true}
    },
    {
        path: '/',
        name: 'Messenger',
        component: () => import('@/views/messenger/Messenger.vue'),
        meta: {requiresAuth: true, requiresRole: true},
        props: route => ({
            contractId: Number(route.params.contractId)
        }),
        children: [
            {
                path: '/',
                name: 'Contracts',
                component: () => import('@/views/messenger/Messenger.vue'),
                meta: {
                    showNavbarMobile: true
                }
            },
            {
                path: 'chat/:contractId(\\d+)',
                name: 'Chat',
                component: () => import('@/views/messenger/Messenger.vue'),
                meta: {
                    showNavbarMobile: false
                }

            },
            {
                path: 'conversation/:conversationId(\\d+)',
                name: 'Conversation',
                component: () => import('@/views/messenger/Messenger.vue'),
                meta: {
                    showNavbarMobile: false
                }

            },
            {
                path: 'info/:contractId(\\d+)',
                name: 'Info',
                component: () => import('@/views/messenger/Messenger.vue'),
                meta: {
                    showNavbarMobile: false
                }
            }
        ]
    },
    {
        path: '/sentry-test',
        name: 'SentryTest',
        component: {
            template: '<div>Тестовая страница для проверки Sentry</div>',
            setup() {
                // Выбрасываем тестовую ошибку
                throw new Error('Тестовая ошибка для Sentry');
            }
        },
        meta: {requiresAuth: false}
    }

];

const router = createRouter({
    history: createWebHistory(),
    routes
});

// Проверка авторизации
router.beforeEach(async (to, from, next) => {
    const store = useAccountStore();

    const has_auth = store.isAuthorized();
    const has_role = store.hasRole();

    if (to.meta.requiresAuth && !has_auth) {
        next({name: 'Login'});
    } else if (to.meta.withoutAuth && has_auth) {
        next({name: 'Contracts'});
    } else if (to.meta.requiresRole && !has_role) {
        next({name: 'Role'});
    } else {
        next();
    }
});

emitter.on('loggedOut', async () => {
    router.push('/login');
})

export default router;
